// import React, {useEffect, useState} from 'react';
// import {DateObject} from "react-multi-date-picker";
// import Avatar from "../../../system/components/avatar";
// import ZofinoCalendar from "../../../system/components/zofino-calendar";
// import TaskSidebar from "../../projects/components/task-sidebar";
// import TaskDialog from "../../tasks/task-dialog";
// import TaskListFilter from "../../tasks/components/task-list-filter";
//
//
// function Calendar({tasks,createTask, updateTask}) {
//     const calendarToolbarId = "project-calendar-toolbar";
//     const [events, setEvents] = useState([]);
//     const [selectedTask, setSelectedTask] = useState();
//     const [taskDialogVisible, setTaskDialogVisible] = useState();
//     const [selectedDate, setSelectedDate] = useState();
//     const [filteredTasks, setFilteredTasks] = useState(tasks ?? []);
//
//     useEffect(() => {
//         setFilteredTasks(tasks ?? []);
//     }, [tasks]);
//
//     useEffect(() => {
//         setEvents(filteredTasks.filter(t=>t.startAt!==null||t.dueDate!==null).map(task=>(
//             {
//                 id:task.documentId,
//                 title:task.title,
//                 backgroundColor: task.taskStatus==="done"?"var(--surface-50)":"var(--green-500)",
//                 borderColor: task.taskStatus==="done"?"var(--surface-200)":"var(--green-500)",
//                 textColor: task.taskStatus==="done"?"black":"white",
//                 start:new DateObject(task.startAt).format("YYYY-MM-DD"),
//                 end:new DateObject(task.dueDate).format("YYYY-MM-DD"),
//                 data:task
//             })))
//         // setEvents([
//         //     {
//         //         id: 1,
//         //         title: "All-day event",
//         //         start: new DateObject().toDate(),
//         //         end: new DateObject().add(2,"days").toDate()
//         //     },
//         //     {
//         //         id: 2,
//         //         title: "Timed event",
//         //         start: new DateObject().toDate(),
//         //         end: new DateObject().toDate()
//         //     }
//         // ])
//     }, [filteredTasks]);
//
//     const EventTemplate = (arg) => {
//
//         const taskData = arg.event.extendedProps.data;
//
//         return (
//             <div className={`flex align-items-center gap-2 p-1 ${taskData?.taskStatus==="done"&&"line-through opacity-60 text-400"}`}>
//                 {taskData?.assignee?.member&&<Avatar className="text-3xs text-600" style={{width:"1.3rem", height:"1.3rem"}} memberData={taskData.assignee.member}/>}
//                 <div className="flex flex-column text-xs">
//                     <span className="text-xs">{arg.event.title}</span>
//                     <span className="opacity-70">{arg.timeText}</span>
//                 </div>
//             </div>
//         );
//     }
//
//     return(
//         <div className="h-full min-h-0 flex flex-column">
//             <TaskListFilter calendarMode calendarToolbarId={calendarToolbarId} showDateFilter tasks={tasks} onChange={setFilteredTasks}/>
//             <div className="flex-1 min-h-0">
//                 <ZofinoCalendar toolbarTargetId={calendarToolbarId} onAddEventClick={(e)=>{setSelectedDate(e);setTaskDialogVisible(true)}} eventTemplate={EventTemplate} events={events} setEvents={setEvents} onEventClick={(e)=>{setSelectedTask(e.event.extendedProps.data)}} onEventResize={(e)=>{updateTask(e.event.extendedProps.data, {startAt:e.event.start, dueDate:e.event.end})}} onEventDropped={(e)=>{updateTask(e.event.extendedProps.data, {startAt:e.event.start, dueDate:e.event.end})}}/>
//             </div>
//             {tasks&&<TaskSidebar selectedTask={tasks.find(task=>task.id===selectedTask?.id)} setSelectedTask={setSelectedTask} updateTask={updateTask} />}
//             <TaskDialog setVisible={setTaskDialogVisible} visible={taskDialogVisible} payload={{taskData:{startAt:new Date(selectedDate).getTime()/1000, dueDate: new Date(selectedDate).getTime()/1000}}} onSubmit={(e)=>{createTask(e); setTaskDialogVisible(false)}}/>
//         </div>
//     )
// }
//
// export default Calendar;


import React, {useEffect, useState} from 'react';
import ZofinoCalendar from "../../../system/components/zofino-calendar";
import TaskSidebar from "../../projects/components/task-sidebar";
import TaskDialog from "../../tasks/task-dialog";
import TaskListFilter from "../../tasks/components/task-list-filter";
import {calendarEventFromTask, CalendarEventContent, useRecurrenceCalendar} from "../../tasks/components/recurrence-calendar";

function Calendar({tasks, createTask, updateTask, projectData}) {
    const calendarPrimaryToolbarId = "project-calendar-primary-toolbar";

    const [events, setEvents] = useState([]);
    const [selectedTask, setSelectedTask] = useState();
    const [taskDialogVisible, setTaskDialogVisible] = useState();
    const [selectedDate, setSelectedDate] = useState();
    const [filteredTasks, setFilteredTasks] = useState(tasks ?? []);
    const recurrence = useRecurrenceCalendar({
        tasks,
        updateTask,
        setSelectedTask,
        projectDocumentId: projectData?.documentId,
    });

    useEffect(() => {
        setFilteredTasks(tasks ?? []);
    }, [tasks]);

    useEffect(() => {
        setEvents(
            filteredTasks
                .filter(t => t.startAt !== null || t.dueDate !== null)
                .map(calendarEventFromTask)
        );
    }, [filteredTasks]);

    return (
        <div className="h-full min-h-0 flex flex-column">
            <TaskListFilter
                calendarMode
                calendarPrimaryToolbarId={calendarPrimaryToolbarId}
                showDateFilter
                tasks={tasks}
                onChange={setFilteredTasks}
            />

            <div className="flex-1 min-h-0">
                <ZofinoCalendar
                    taskToolbar
                    primaryToolbarTargetId={calendarPrimaryToolbarId}
                    onAddEventClick={(e) => {
                        setSelectedDate(e);
                        setTaskDialogVisible(true);
                    }}
                    eventTemplate={CalendarEventContent}
                    events={[...events, ...recurrence.projectedEvents]}
                    setEvents={setEvents}
                    onRangeChange={recurrence.onRangeChange}
                    onEventClick={recurrence.onEventClick}
                    onEventResize={recurrence.onEventResize}
                    onEventDropped={recurrence.onEventDropped}
                />
            </div>

            {tasks && (
                <TaskSidebar
                    selectedTask={tasks.find(task => task.id === selectedTask?.id) ?? selectedTask}
                    setSelectedTask={setSelectedTask}
                    updateTask={updateTask}
                />
            )}
            {recurrence.scopeDialog}

            <TaskDialog
                setVisible={setTaskDialogVisible}
                visible={taskDialogVisible}
                payload={{
                    taskData: {
                        startAt: new Date(selectedDate).getTime() / 1000,
                        dueDate: new Date(selectedDate).getTime() / 1000
                    }
                }}
                onSubmit={(e) => {
                    createTask(e);
                    setTaskDialogVisible(false);
                }}
            />
        </div>
    );
}

export default Calendar;
